import React, { useEffect, useState } from "react";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import { FormattedMessage, useIntl } from "react-intl";
import { Container, TitleContainer, Title, SegmentLabel } from "./styles";

import { Segmented, notification } from "antd";
import { useSelector } from "react-redux";
import { getReportFilterYearsService } from "../../../service/reportFilter.service";
import { LoadingComponent } from "../../../newUXPages/InformaAcademy/Course/styles";
import { LoadingSpinnerLogo } from "../../../components/LoadingOverlay/styles";
import LogoCircle from "../../../assets/images/Informa_Logo_Circle.png";
import CoursesAnalytics from "./Courses";
import BannerAnalytics from "./Banner";

const OPTIONS = [
  {
    label: <SegmentLabel>Banner</SegmentLabel>,
    value: "banner",
  },

  {
    label: (
      <SegmentLabel>
        <FormattedMessage id={"sidebar.courses"} />
      </SegmentLabel>
    ),
    value: "courses",
  },
];

export default function InformaAcademyAnalytics() {
  const [analytics, setAnalytics] = useState("banner");
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const { bannersTotalActions, coursesTotalActions } = useSelector(
    (state) => state.analytics
  );

  const [years, setYears] = useState([]);
  const [loadingYears, setLoadingYears] = useState(true);

  useEffect(() => {
    let active = true;

    (async () => {
      setLoadingYears(true);
      try {
        const response = await getReportFilterYearsService({ token });
        if (!active) {
          return;
        }
        setYears(
          (response.data?.output ?? []).map((year) => ({
            value: year,
            label: String(year),
          }))
        );
      } catch (error) {
        if (active) {
          setYears([]);
          notification.error({
            message: intl.formatMessage({ id: "error" }),
            description: intl.formatMessage({
              id: "api.error." + (error.response?.data?.code || "default"),
            }),
          });
        }
      } finally {
        if (active) {
          setLoadingYears(false);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [token, intl]);

  const selectedSegment =
    analytics === "banner"
      ? "Banner"
      : intl.formatMessage({ id: "sidebar.courses" });

  if (loadingYears) {
    return <Loading />;
  }

  return (
    <AnimatedMainContainer breadcrumb={`Informa Academy | Analytics`}>
      <Container>
        <TitleContainer>
          <Title>Dashboard | {selectedSegment}</Title>
          <Segmented
            options={OPTIONS}
            value={analytics}
            onChange={setAnalytics}
            trackBg={"#000"}
          />
        </TitleContainer>

        {analytics === "courses" && (
          <CoursesAnalytics
            coursesTotalActions={coursesTotalActions}
            years={years}
          />
        )}
        {analytics === "banner" && (
          <BannerAnalytics
            bannersTotalActions={bannersTotalActions}
            years={years}
          />
        )}
      </Container>
    </AnimatedMainContainer>
  );
}

function Loading() {
  return (
    <LoadingComponent>
      <div>
        <LoadingSpinnerLogo src={LogoCircle} />
      </div>
    </LoadingComponent>
  );
}
